import clearSelect from "./lib/clear-select";

const postalCodeText = document.getElementById('postal-code')
const countrySelect = document.getElementById('country-id')
const provinceSelect = document.getElementById('province-id')
const citySelect = document.getElementById('city-id')
const districtSelect = document.getElementById('district-id')

if (countrySelect) {
    countrySelect.addEventListener(
        'change',
        async () => {
            const emptyOption = document.createElement('option')
            const apiUrl = new URL(countrySelect.dataset.apiUrl)
            apiUrl.searchParams.set('countryId', countrySelect.value)
            const response = await fetch(apiUrl)
            const json = await response.json()
            clearSelect(provinceSelect)
            clearSelect(citySelect)
            document.getElementById('city-row')?.classList.add('hidden')
            if (json.provinceOptions.length === 0) {
                document.getElementById('province-row')?.classList.add('hidden')
                return
            }
            updateSelect(provinceSelect, json.provinceOptions)
            document.getElementById('province-row')?.classList.remove('hidden')
        }
    )
}

if (provinceSelect) {
    provinceSelect.addEventListener(
        'change',
        async function () {
            const emptyOption = document.createElement('option')
            const apiUrl = new URL(this.dataset.apiUrl)
            apiUrl.searchParams.set('countryId', countrySelect?.value || 'JP')
            apiUrl.searchParams.set('provinceId', this.value)
            const response = await fetch(apiUrl)
            const json = await response.json()
            clearSelect(citySelect)
            if (districtSelect) {
                clearSelect(districtSelect)
            }
            if (json.cityOptions.length === 0) {
                document.getElementById('city-row')?.classList.add('hidden')
                return
            }

            document.getElementById('city-row')?.classList.remove('hidden')
            updateSelect(citySelect, json.cityOptions)
        }
    )
}

if (citySelect && districtSelect) {
    citySelect.addEventListener(
        'change',
        async function () {
            const apiUrl = new URL(this.dataset.apiUrl)
            apiUrl.searchParams.set('cityId', this.value)
            const response = await fetch(apiUrl)
            const json = await response.json()
            updateSelect(districtSelect, json.districtOptions)
        }
    )
    districtSelect.addEventListener(
        'change',
        (e) => {
            postalCodeText.value = e.target.options[e.target.selectedIndex].dataset.postalCode
        }
    )
}

if (postalCodeText) {
    postalCodeText.addEventListener(
        'blur',
        async function () {
            const REGEX = new RegExp(postalCodeText.getAttribute('pattern'))
            const postalCode = postalCodeText.value
            const warningSpan = document.getElementById('invalid-postal-code-warning')
            if (!REGEX.test(postalCode)) {
                warningSpan.classList.remove('hidden')
                return
            }
            warningSpan.classList.add('hidden')
            const apiUrl = new URL(this.dataset.apiUrl)
            apiUrl.searchParams.append('postalCode', postalCode)
            const response = await fetch(apiUrl)
            if (response.status !== 200) {
                warningSpan.classList.remove('hidden')
                return
            }
            const json = await response.json()
            provinceSelect.value = json.provinceId
            updateSelect(citySelect, json.cityOptions)
            citySelect.value = json.cityId
            updateSelect(districtSelect, json.districtOptions)
            districtSelect.value = json.districtId
        }
    )
}

function updateSelect(element, options) {
    clearSelect(element)
    if (options.length === 0) {
        return
    }

    const emptyOption = document.createElement('option')
    emptyOption.textContent = element.dataset.emptyOption
    element.appendChild(emptyOption)
    options.forEach(optionData => {
        const optionElement = document.createElement('option')
        optionElement.value = optionData.value
        optionElement.textContent = optionData.label
        if (optionData.postalCode) {
            optionElement.dataset.postalCode = optionData.postalCode
        }
        element.appendChild(optionElement)
    })
}
